"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const Sentry = __importStar(require("./Sentry"));
//
// components
//
const LogIn = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/onboarding/Login'))));
const Register = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/onboarding/Register'))));
const PasswordRecovery = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/onboarding/PasswordRecovery'))));
const PasswordReset = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/onboarding/PasswordReset'))));
const Dashboard = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./components/Dashboard'))));
const LoadingSpinner_1 = __importDefault(require("./components/general/LoadingSpinner"));
const useDelighted_1 = require("./components/useDelighted");
//
// styles
//
const StyledLoadingContainer_1 = require("./StyledLoadingContainer");
const tokenHeader_1 = require("./tokenHeader");
const queryDefinitions_1 = require("./queryDefinitions");
const withAccount_1 = require("./components/withAccount");
const addFeatureFlagHandlers_1 = require("./addFeatureFlagHandlers");
const AuthContext_1 = require("./AuthContext");
const Root = ({ isLoggedIn, onLogout, ldClient, account }) => {
    var _a;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((options?... Remove this comment to see the full error message
    const [getUser, { data }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_USER);
    const { setLogoutFunction } = (0, react_1.useContext)(AuthContext_1.AuthContext);
    const userId = (_a = data === null || data === void 0 ? void 0 : data.currentUser) === null || _a === void 0 ? void 0 : _a.id;
    (0, useDelighted_1.useDelighted)({ mount: isLoggedIn });
    (0, react_1.useEffect)(() => {
        setLogoutFunction(onLogout);
    }, [onLogout]);
    (0, react_1.useEffect)(() => {
        if (isLoggedIn) {
            // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
            getUser();
        }
    }, [isLoggedIn]);
    (0, react_1.useEffect)(() => {
        if (userId) {
            Sentry.setUser(userId);
        }
        else {
            Sentry.clearUser();
        }
    }, [userId]);
    (0, react_1.useEffect)(() => {
        if (!data) {
            return;
        }
        if ((0, isEmpty_1.default)(account)) {
            return;
        }
        const { currentUser } = data;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'pendo' does not exist on type 'Window & ... Remove this comment to see the full error message
        window.pendo.initialize({
            visitor: {
                id: currentUser.id,
                email: currentUser.email,
                full_name: currentUser.name,
                admin_role: currentUser.admin
            },
            account: {
                id: account.id,
                name: account.name
            }
        });
    }, [data, account]);
    (0, react_1.useEffect)(() => {
        if (!data) {
            return;
        }
        if (!ldClient) {
            return;
        }
        const { currentUser } = data;
        const user = {
            key: currentUser.id,
            email: currentUser.email,
            name: currentUser.name,
            custom: {
                admin: currentUser.admin,
                accountName: account.name
            }
        };
        ldClient.identify(user, null);
    }, [data, ldClient, account]);
    function fallbackRoute() {
        if (isLoggedIn) {
            return '/';
        }
        return '/login';
    }
    function routes() {
        let routesArray = [
            react_1.default.createElement(react_router_dom_1.Route, { key: 'login', path: '/login' },
                react_1.default.createElement(LogIn, null)),
            react_1.default.createElement(react_router_dom_1.Route, { key: 'register', path: '/register' },
                react_1.default.createElement(Register, null)),
            react_1.default.createElement(react_router_dom_1.Route, { key: 'recovery', path: '/password_recovery' },
                react_1.default.createElement(PasswordRecovery, null)),
            react_1.default.createElement(react_router_dom_1.Route, { key: 'PasswordReset', path: '/password_reset/:code' },
                react_1.default.createElement(PasswordReset, null))
        ];
        if (isLoggedIn) {
            routesArray = routesArray.concat([
                react_1.default.createElement(react_router_dom_1.Route, { key: 'dashboard', path: '/' },
                    react_1.default.createElement(Dashboard, { onLogout: onLogout }))
            ]);
        }
        return routesArray;
    }
    return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(StyledLoadingContainer_1.StyledLoadingContainer, null,
                react_1.default.createElement(LoadingSpinner_1.default, null)) },
            react_1.default.createElement(react_router_dom_1.Switch, null,
                routes().map((r) => Object.assign({}, r, { key: r.props.path })),
                react_1.default.createElement(react_router_dom_1.Redirect, { to: fallbackRoute() })))));
};
const featureFlagHandler = (0, addFeatureFlagHandlers_1.getFeatureFlagHandler)();
exports.default = featureFlagHandler((0, withAccount_1.withAccount)(Root));
